"use client";

import { TypographyH1 } from "@/components/ui/typography";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

export function QuestionTitle({ question }: { question: string }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div>
      <TypographyH1
        className={`text-left text-base lg:text-xl ${!isExpanded ? "line-clamp-2" : ""}`}
      >
        {question}
      </TypographyH1>

      <div className="mt-2 flex w-full items-center justify-center text-emerald-600 hover:text-emerald-500">
        {isExpanded ? (
          <span
            className=" flex cursor-pointer items-center"
            onClick={handleClick}
          >
            むっと少なく見る <ChevronUp className="ml-1 h-4 w-4" />
          </span>
        ) : (
          <span
            className="flex cursor-pointer items-center"
            onClick={handleClick}
          >
            もっと見る <ChevronDown className="ml-1 h-4 w-4" />
          </span>
        )}
      </div>
    </div>
  );
}
